import axios from "axios"

const baseDomain = process.env.BASE_API_URL
const baseApiUrl = `${baseDomain}`

const user = JSON.parse(localStorage.getItem("user"))

let http = axios.create({
  baseURL: baseApiUrl,
})

http.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status == 401) {
      // console.log("got 401, so reloading")
      // location.reload()
      location.href = `${process.env.SSO_BASE_URL}/mycircles`
    }
  }
)

if (user) {
  // if (user.hasOwnProperty("verified_account")) {
  //   console.log("not-verified");
  //   break;
  // } else if (user.user.token) {
  //   http.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`;
  // }
  user.user.hasOwnProperty("verified_account") ? console.log("not verified") : (http.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`)
}

export default http



// WEBPACK FOOTER //
// ./src/repositories/Repository.js